import { useConfirm } from 'legacy/lut/components/shared/Confirm/useConfirm'
import React, { FC, useEffect } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { CommitmentChangeDialog } from '../../../../../commitment/CommitmentChangeDialog'
import { WidgetHeader } from '../../../../../widgetHeader/WidgetHeader'

import { SIGNATURE_DROP_DIALOG } from './configs'
import { ISignatureDropDialogProps } from './models/signatureDropDialogProps'

import styles from './SignatureDropDialog.module.scss'

export const SignatureDropDialog: FC<ISignatureDropDialogProps> = ({
  partnerId,
  programType,
  fYear,
  metrics,
}) => {
  const { confirmState, onConfirm, onCancel, registerConfirmDialog, unregisterConfirmDialog } =
    useConfirm()

  const handleConfirm = () => {
    onConfirm(SIGNATURE_DROP_DIALOG)
  }

  const handleCancel = () => {
    onCancel(SIGNATURE_DROP_DIALOG)
  }

  useEffect(() => {
    registerConfirmDialog(SIGNATURE_DROP_DIALOG)

    return () => {
      unregisterConfirmDialog(SIGNATURE_DROP_DIALOG)
    }
  }, [])

  return (
    <ModalDialog
      show={!!confirmState[`${SIGNATURE_DROP_DIALOG}`]}
      size="sm"
      content={CommitmentChangeDialog}
      onClose={handleCancel}
      header={() => (
        <WidgetHeader className={styles.modalDialogHeader}>jbp-confirm-changes</WidgetHeader>
      )}
      contentProps={{
        partnerId,
        programType,
        metrics,
        fyear: fYear,
        onApply: handleConfirm,
        onCancel: handleCancel,
      }}
    />
  )
}
